import {authHeader} from "../util/auth-header";
import http from "../util/http-common";

export class VinFragmentService {

    static async retrieveVinFragment(vinFragment: string) {
        return http.get(
            `/cfadminvinadmin/api/v1/vin-fragment-management/retrieveVinFragment?vinFragment=${encodeURIComponent(vinFragment)}`,
            {headers: await authHeader()}
        );
    }

    static async newVinFragmentUpdate(data: any) {
        return http.put(
            `/cfadminvinadmin/api/v1/vin-fragment-management/vinFragmentUpdate`,
            data,
            {headers: await authHeader()}
        );
    }

    static async cloneVinFragment(data: any) {
        return http.post(
            `/cfadminvinadmin/api/v1/vin-fragment-management/vinFragmentClone`,
            data,
            {headers: await authHeader()}
        );
    }

    static async createVinFragment(data: any) {
        return http.post(
            `/cfadminvinadmin/api/v1/vin-fragment-management/vinFragmentCreate`,
            data,
            {headers: await authHeader()}
        );
    }
}

export default VinFragmentService;
